import { useState } from "react";
import addIcon from "../../../../../src/assets/img/addicon.svg";
import api from "../../../../config/api";

const AddPreference = ({ categorySelected, preferences, getPreferences }) => {
  const [inputActive, setInputActive] = useState(false);
  const [inputTitle, setInputTitle] = useState("");

  const savePreferece = async (e) => {
    setInputTitle(() => e.target.value);
    let object;
    object = {
      category: categorySelected,
      preferences: preferences?.preferences.length
        ? [...preferences?.preferences, { title: e.target.value, description: [] }]
        : [{ title: e.target.value, description: [] }],
    };
    if (!inputTitle) return;
    if (e.type === "keyup") {
      if (e.key === "Enter") {
        await api.post(`/preferences/`, object).then((resp) => {
          getPreferences(categorySelected);
          document.getElementById("inputTitlePreference").blur();
        });
      }
    }
  };

  const activeInputTitle = () => {
    setInputActive(true);
    setTimeout(() => {
      document.getElementById("inputTitlePreference").focus();
    }, 100);
  };

  return (
    <div
      className=" mb-16 mt-32 d-flex bg-light-gray-preference p-4 col-12 rounded-1 align-items-center"
      onBlur={() => setInputActive(false)}
    >
      <div className="d-flex border-0 col-auto c-pointer align-items-center rounded-1">
        {inputActive ? (
          <div
            className="border-0 ff-univanova fz-16 c-pointer p-2 py-1 form-control bg-transparent text-cl-black-4  d-flex align-items-center"
            onBlur={() => setInputActive(false)}
          >
            <input
              id="inputTitlePreference"
              className="bg-transparent border-0 border-none form-control shadow-none ff-univanova-regular"
              onKeyUp={(e) => savePreferece(e)}
            />
          </div>
        ) : (
          <div
            className="border-0 ff-univanova fz-16 c-pointer p-2  form-control bg-transparent text-cl-black-4  d-flex align-items-center"
            onClick={() => activeInputTitle()}
          >
            <img alt="delete variation" className="me-2" src={addIcon} />
            <span>
              Adicione e pressione <strong>Enter</strong> para adicionar uma nova variação
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddPreference;
